
























import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { SITE_LANG } from "../store/getters.names";
import { Label } from "../store/store.types";

@Component({
  name: "ExamContentCard"
})
export default class ExamContentCard extends Vue {
  @Getter(SITE_LANG) lang;
  @Prop() content: any;
  @Prop() label: Label;

  get examName(): string {
    let name = this.content[`name_${this.lang}`];
    if (name && name.length > 0) {
      return name;
    } else {
      return this.content.name;
    }
  }
}
